import React from 'react';
import Notification from './Notification';
import * as ReactDOM from 'react-dom';
import { IActionInfo } from './Alert';

function newInstance(callback) {
    let notice: HTMLElement = document.getElementById('notice') as HTMLElement;
    if (!notice) {
        notice = document.createElement('div');
        document.body.appendChild(notice);
    }

    let called = false;

    function ref(notification) {
        if (called) {
            return;
        }
        called = true;
        callback({
            toast: (text: any, duration?: number, mask?: boolean) => {
                notification.toast(text, duration, mask);
            },
            remove: (key) => {
                notification.remove(key);
            },
            component: notification,
            destroy: () => {
                ReactDOM.unmountComponentAtNode(notice);
            }
        });
    }

    ReactDOM.render(
        <Notification ref={ref}/>,
        notice
    );
}

var notification;

function getNotification(callback: (notification: Notification) => void) {
    if (notification) {
        callback(notification);
        return;
    }
    newInstance((obj) => {
        notification = obj.component;
        callback(notification);
    });
}

export function toast(text: any, duration?: number, mask?: boolean) {
    getNotification((notification) => {
        notification.toast(text, duration, mask);
    });
}

export function TeXiao(text?: any, duration?: number, mask?: boolean) {
    getNotification((notification) => {
        notification.TeXiao(text, duration, mask);
    });
}

export function alert(text: any, actions: IActionInfo[], msg?: any) {
    getNotification((notification) => {
        notification.alert(text, actions, msg);
    });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/notice/index.tsx